import { AuthService } from 'src/app/core/auth/auth.service';
import { Router } from '@angular/router';
import { MainMenuService } from 'src/app/shared/services/mainmenu.service';
import { CallbackAction, GotoAction, ModalAction } from 'src/app/shared/models/action';
import { GeneralService } from 'src/app/shared/services/general.service';
import { Injectable } from '@angular/core';
import { SharedController } from 'src/app/shared/shared-controller';
import { AppLoadingService } from 'src/app/shared/services/apploading.service';

declare var window:any;

@Injectable({
    providedIn: 'root'
})
export class HomeController extends SharedController {

    constructor(protected mms: MainMenuService,
        protected route: Router,
        protected auth: AuthService,
        public gs: GeneralService,
        protected als: AppLoadingService){
            super(mms, route, auth, gs);
            //this.ngOnInit();
    }

    init(){
        let th = this;
        this.setMainMenu([
            //new GotoAction('header','Home', ['/'], {}, this.route),
            //new GotoAction('header','Como funciona?', ['/about'], {}, this.route),
            //new ModalAction('header','Contato', 'SignUpComponent'),
            //new ModalAction('header','Quero anunciar', 'AdvertiseFormComponent'),
            new CallbackAction('headerRight','Quero anunciar', () => {
                var  element = document.createElement('a') as HTMLElement;
                element.setAttribute('href', (window?.mobileAndTabletCheck()? 'whatsapp://send': 'https://web.whatsapp.com/send')+'?phone='+(th.gs.settingsData?.comercialPhone? th.gs.settingsData?.comercialPhone : '+5547991196837')+'&text=Olá, gostaria de saber como posso anunciar meus empreendimentos na Central Corretor');
                element.setAttribute('style', 'display:none;');
                element.setAttribute('target', '_blank');
                element.click();
            }),
            new ModalAction('headerRight','Cadastre-se', 'SignUpComponent')
        ]);

        this.loadButtons();
        this.gs.setOptions({headerScrollTop : 50});
        const elBody = document.getElementsByTagName("body")[0];
        elBody.classList.add('home');
    }
}